export default "__VITE_ASSET__Bu_Weawd__"